import { render, staticRenderFns } from "./trainingsHubExerciseExplorer.vue?vue&type=template&id=4be003fc&scoped=true"
import script from "./trainingsHubExerciseExplorer.vue?vue&type=script&lang=js"
export * from "./trainingsHubExerciseExplorer.vue?vue&type=script&lang=js"
import style0 from "./trainingsHubExerciseExplorer.vue?vue&type=style&index=0&id=4be003fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be003fc",
  null
  
)

export default component.exports